package com.loyola.acessoescola.ui

import com.loyola.acessoescola.services.QuickAuthClient
import com.loyola.acessoescola.services.adminpanel.AdminPanelApi
import com.loyola.acessoescola.ui.adminpanel.AdminPanelViewModel

private val adminPanelApi = AdminPanelApi()
actual fun createAdminPanelViewModel(
    quickAuthClient: QuickAuthClient
): AdminPanelViewModel {
    return AdminPanelViewModel(
        adminPanelApi = adminPanelApi,
        quickAuthClient = quickAuthClient,
        acessoEscolaAPI = acessoEscolaAPI
    )
}